
import EDBox from '../../../../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { EDTextEdit } from '../../../../../BaseComponents/TextEdit/EDTextEdit';
import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton';
import { IBusinessDataFormContext } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';

interface IQrCodeHandlerProps {
  QRText: string;
  setQRText: React.Dispatch<React.SetStateAction<string>>;
  addQRValues: (value: string, formContext: any) => void;
  formContext: IBusinessDataFormContext<any, unknown>;
}

const QrCodeHandler: React.FC<IQrCodeHandlerProps> = ({
  QRText,
  setQRText,
  addQRValues,
  formContext,
}) => {
  const cleanQRString = (str: string) => {
    let i = 0;
    const length = str.length;
    const isValidChar = (char: string) => /[0-9A-Za-z]/.test(char);

    while (i < Math.min(5, length) && !isValidChar(str[i])) {
      i++;
    }
    if (i >= 4) {
      throw new Error(`QR code could not be interpreted - "${str}"`);
    }
    return str.substring(i);
  };

  return (
    <EDBox
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        width: '100%',
      }}
    >
      <EDTypography sx={{ marginRight: 1, whiteSpace: 'nowrap' }}>
        Markera här för inläsning av QR-koden:
      </EDTypography>
      <EDTextEdit
        value={'*'.repeat(QRText.length)}
        onChange={e => {
          const newChar = e.slice(QRText.length);
          setQRText(QRText + newChar);
        }}
        testId="QRCodeField"
        onReset={() => {
          setQRText('');
        }}
      />
      <EDButton
        label="OK"
        marginTop={0.9}
        marginLeft={1}
        onClick={() => {
          addQRValues(cleanQRString(QRText), formContext);
        }}
        testId="QRCodeButton"
      />
    </EDBox>
  );
};

export default QrCodeHandler;
